import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ServicesService } from '../../../views/services/services.service';
import { ToastService } from '../../../core/services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-incident-report-modal',
    templateUrl: './incident-report-modal.component.html',
    styleUrls: ['./incident-report-modal.component.scss'],
})
export class IncidentReportModalComponent {
    @Output() closed = new EventEmitter<void>();
    @Input() rawReportData = '';
    @Input() searchValue = '';

    summary = '';
    description = '';
    reportSuccess = false;
    submmited = false;

    constructor(
        private servicesService: ServicesService,
        private toast: ToastService,
        private translate: TranslateService
    ) {}

    close() {
        this.closed.emit();
    }

    report() {
        if (this.submmited || this.summary.length > 255 || this.description.length > 5000) return;
        const body = {
            rawResponseJson: JSON.parse(this.rawReportData),
            summary: this.summary,
            description: this.description,
            inputAddress: this.searchValue
        };

        this.submmited = true;
        this.servicesService.reportAddress(body).subscribe(
            (val) => {
                this.submmited = false;
                if (val?.status && val?.data) {
                    this.reportSuccess = true;
                } else {
                    const errorMsg = this.translate.instant('notifications.incident.errorOccurred');
                    this.toast.error(errorMsg);
                }
            },
            () => {
                const errorMsg = this.translate.instant('notifications.incident.errorOccurred');
                this.toast.error(errorMsg);
                this.submmited = false;
            }
        );
    }
}
